import { BaseParams } from '@/datamodel/urlparams/BaseParams'
import { LoginParam } from '@/datamodel/urlparams/LoginParams'
import { LogoutParams } from '@/datamodel/urlparams/LogoutParams'
import { ACT } from '@/utils/constants'
import service from '@/utils/request'
import { AxiosPromise } from 'axios'
import { AxiosSource } from '.'

export function login(model: LoginParam): AxiosPromise<string> {
    return service({
        method: 'POST',
        params: model,
        cancelToken: AxiosSource.Source.token
    })
}

export function trialLogin(): AxiosPromise<string> {
    return service({
        method: 'POST',
        params: new BaseParams(ACT.TRIAL),
        cancelToken: AxiosSource.Source.token
    })
}

export function logout(model: LogoutParams): AxiosPromise<string> {
    return service({
        method: 'POST',
        params: model,
        cancelToken: AxiosSource.Source.token
    })
}
